import Request from "../../../core/httpClient";
import { condonarTipos } from "./pagoTypes";

const request = new Request();

export const getViviendasDocuments = async (id_fraccionamiento) => {

    try {

        const data = { id_fraccionamiento };
        const response = await request.post("/documentos/get/documents", data);
        const { documents, propietarios, empty, message, error } = response || { error: true, message: "ERROR DE CONEXIÓN" };

        if (error) {
            return { error, message: message || "No se pudieron cargar los documentos de las viviendas" };
        };

        if (empty || !documents) {
            return { empty: true, message };
        };

        if (propietarios) {

            const documentos = documents.map((doc) => {

                const foundPropietario = !propietarios.empty ?
                    propietarios.find(({ id_vivienda }) => id_vivienda === doc.Id_Vivienda)
                    : undefined;

                if (foundPropietario) {
                    doc.Propietario = foundPropietario.nombre;
                };

                return doc;
            });

            return { documentos };

        } else {

            const documentos = documents;

            return { documentos };
        };

    } catch (error) {
        console.log(error);
        return { error, message: error };
    }
};

export const getViviendaDataDocuments = async (id_fraccionamiento) => {

    try {

        const data = { id_fraccionamiento };
        const response = await request.post("/documentos/get/data/documents", data);
        const { data: dataDocs, empty, message, error } = response || { error: true, message: "ERROR DE CONEXIÓN" };

        if (error) return {
            error, message: message || "No se pudieron cargar los documentos de generacion las viviendas"
        };

        if (empty) return { empty: true, message };

        return { dataDocs };

    } catch (error) {
        console.log(error);
        return { error, message: error };
    }
};

export const postCreateGeneracion = async ({ id_fraccionamiento, id_subfraccionamiento, mes, year, user }) => {

    try {

        const data = {
            id_fraccionamiento,
            id_subfraccionamiento,
            mes,
            year,
            user
        };

        const response = await request.post("/documentos/create/documents", data);
        const { created, message } = response || { message: "ERROR DE CONEXIÓN" };

        if (created) return { created, message: "Documentos generados correctamente" };

        return { error: true, message: message || "No se pudieron generar los documentos" };

    } catch (error) {
        console.log(error);
        return { error, message: error };
    }
};

export const postValidateImportDocuments = async (id_fraccionamiento, doc_lineas) => {
    try {
        const data = { id_fraccionamiento, doc_lineas };

        const response = await request.post("/documentos/validate/import", data);
        const { tabla, empty, error, message } = response || { error: true, message: "ERROR DE CONEXIÓN" };

        if (error) return { error: true, message: message || "Error al validar los documentos." };
        if (empty) return { rows: [], message };

        return { rows: Array.isArray(tabla) ? tabla : [] };

    } catch (error) {
        console.log(error);
        return { error: true, message: String(error) };
    }
};

export const postImportDocument = async ({ id_fraccionamiento, sobreescribir, array, userId, }) => {

    try {

        const data = {
            id_fraccionamiento,
            sobreescribir,
            array,
            userId
        };

        const response = await request.post("/documentos/import/document", data);
        const { tabla, message } = response || { message: "ERROR DE CONEXIÓN" };

        if (Array.isArray(tabla)) {
            return { tabla, message: "Datos importados. " };
        };

        return { error: true, message: message || "Error al importar los documentos." };

    } catch (error) {
        console.log(error);
        return { error, message: error };
    }
};

export const getExportarDocuments = async ({ id_fraccionamiento, date }) => {

    try {

        const data = { id_fraccionamiento, date };
        const response = await request.post("/documentos/get/config/export", data);
        const { data: dataExport, empty, error } = response || { error: true, message: "ERROR DE CONEXIÓN" };

        if (error) return {
            error: true, message: "Error al exportar los documentos."
        };

        if (empty) return {
            message: "No se encontraron datos para exportar."
        };

        return { dataExport, message: "El documento se exportará en unos instantes." };

    } catch (error) {
        console.log(error);
        return { error, message: error };
    };
};

export const getConfigDocuments = async (id_fraccionamiento) => {
    try {

        const data = { id_fraccionamiento };
        const response = await request.get("/documentos/get/config/document", data);
        const { Productos, Impuestos, empty, message, error } = response || { error: true, message: "ERROR DE CONEXIÓN" };

        if (error) return { error: true, message: error || message };

        if (empty) return { message: "No se encontro configuracion de documentos. " };

        const configProductos = JSON.parse(Productos);
        const configImpuestos = JSON.parse(Impuestos);

        return { configProductos, configImpuestos };

    } catch (error) {
        console.log(error);
        return { error, message: error };
    };
};

export const postEliminarDocuments = async ({ array, userId }) => {
    try {

        const data = { array, userId };

        const response = await request.post("/documentos/eliminar", data);

        const { tabla, message } = response || { message: "ERROR DE CONEXIÓN" };

        if (Array.isArray(tabla)) {

            return { deleted: true, message: "Datos procesados." }

        } else {

            return { error: true, message: message || "Error al eliminar los documentos." };
        }

    } catch (error) {
        console.log(error);
        return { error, message: error };
    }
};

export const postCreateDocuments = async ({
    id_vivienda, fecha, comentario, lineas, impuestos, userId
}) => {
    try {

        const data = { id_vivienda, fecha, comentario, lineas, impuestos, userId };

        const response = await request.post("/documentos/create/document", data);
        const { created, error, message } = response || { error: true, message: "ERROR DE CONEXIÓN" };

        if (error || !created) return { error: true, message: message || "No fue posible crear el documento." };

        return { created, message: "Nuevo documento creado." };

    } catch (error) {
        console.log(error);
        return { error, message: error };
    }
};

/**
 * Sends all validated import rows in a single bulk request to
 * sp_DCOB_Create_Import_Documents via the /documentos/create/import/documents endpoint.
 *
 * @param {{ rows: Array, usuario: string }} params
 * @returns {{ created: boolean, error: boolean, message: string }}
 */
export const postCreateImportDocuments = async ({ rows, usuario }) => {
    try {
        const lineas = rows.map((row, index) => ({
            id_linea: index + 1,
            id_vivienda: row.id_vivienda,
            fecha: String(row.MES).padStart(2, "0") + row["AÑO"],
            id_producto: row.id_producto,
            importe: Number(row.IMPORTE ?? 0.00),
            impuestos: Number(row.IMPUESTOS ?? 0.00),
            retenciones: Number(row.RETENCIONES ?? 0.00),
            comentario: row.COMENTARIOS || "",
        }));

        const data = { usuario, lineas: JSON.stringify(lineas) };
        // console.log("Sending import documents with data:", data);
        const response = await request.post("/documentos/create/import/documents", data);
        // console.log("Response from import documents:", response);
        const { created, error, message } = response || { error: true, message: "ERROR DE CONEXIÓN" };

        if (error || !created) return { error: true, message: message || "No fue posible importar los documentos." };

        return { created: true, count: lineas.length, message: message || "Documentos importados correctamente." };
    } catch (error) {
        console.log(error);
        return { error: true, message: error.message || String(error) };
    }
};

export const getDocumentsDetalleByVivienda = async (id_vivienda) => {

    try {
        const data = { id_vivienda };

        const response = await request.post("/documentos/get/documents/byHouse", data);
        const { documentsInfo, empty, error } = response || { error: "ERROR DE CONEXIÓN" };

        if (error || empty) return { error, detail: [] };

        return { detail: documentsInfo };

    } catch (error) {
        return { error, detail: [] };
    }
};

export const getDocumentosPendientesDeCobro = async (id_vivienda) => {
    try {
        const data = { id_vivienda };

        const response = await request.get("/documentos/get/pendientes/cobro", data);

        if (response.empty || response.error) {

            return { saldoAFavor: 0, documentosPendientes: [] };

        } else {

            const { docs, saldoFavor: saldoAFavor } = response;

            const documentosPendientes = JSON.parse(docs).map((doc) => {

                doc.DetalleRecargo = JSON.parse(doc.DetalleRecargo);
                doc.Recargos = 0;
                doc.DetalleDescuento = JSON.parse(doc.DetalleDescuento);
                doc.Descuento = 0;

                if (doc.EstadoCobro === 1) {
                    doc.Descuento = doc.DescuentoCobrado;
                    doc.Recargos = doc.RecargosCobrado;
                    doc.Total = doc.Importe - doc.DescuentoCobrado + doc.RecargosCobrado;
                    doc.Saldo = doc.Importe - doc.DescuentoCobrado + doc.RecargosCobrado - doc.Pagado;
                };

                const condonacionProps = doc.CondonacionCobrado && doc.CondonacionCobrado > 0 ?
                    {
                        Condonacion: doc.CondonacionCobrado,
                        PrevCondonacion: doc.CondonacionCobrado,
                        Condonar: condonarTipos.Previo,
                    }
                    : {
                        Condonacion: 0,
                        PrevCondonacion: 0,
                        Condonar: condonarTipos.No,
                    }

                return Object.assign(doc, {
                    checked: false,
                    ...condonacionProps,
                    PrevPagado: doc.Pagado,
                    Aplicado: 0,
                    Safg: 0, // Saldo a favor generado
                    Fecha: doc.MesAnyo.substring(0, 2) + "-" + doc.MesAnyo.substring(2, 6)
                });
            });

            return { documentosPendientes, saldoAFavor };
        }
    } catch (error) {
        console.log(error);
        return { error: "Error al obtener documentos pendientes" };
    }
};

export const postAplicarPagosDeDocumentosDeCobro = async (
    {
        id_vivienda, fechaRecibo, detallecobro, pagoInfo, abonos,
        saldoAfavor, userName, userId
    }
) => {

    try {

        const { fecha, idMetodoPago, importe, banco, numMovimiento, comentarios } = pagoInfo;

        const formapago = [{
            fechaLinea: fecha,
            idFormaPago: idMetodoPago,
            importePago: importe,
            bancoLinea: banco,
            movimientoLinea: numMovimiento,
            comentarios
        }];

        const data = {
            id_vivienda, fechaRecibo, detallecobro, formapago,
            abonos, saldoAfavorGenerado: saldoAfavor, userName, userId,
        };

        const res = await request.post("/documentos/save/recibo/cobro", data);

        if (res.error || res.empty) {

            return { error: res.error || "No se pudo crear el recibo." }

        } else if (res.created) {

            return { created: true };
        };
    } catch (error) {
        return { error: "No se pudo crear el recibo." };
    }
};

export const postDocumentosPasswordManual = async (password) => {
    try {
        const data = {
            id_fraccionamiento: localStorage.getItem("frac") || 0,
            password,
        };

        const response = await request.get("/documentos/validar/aplicacion/manual", data);

        if (response) {

            localStorage.setItem("permisoManual", JSON.stringify({ permisoManual: response.valid }));
            return { valid: response.valid };

        } else {

            return { error: "Error de conexión" }
        }
    } catch (error) {
        console.log(error);
        return { error: "Error al checar password" };
    }
};